import { createContext, useState, useEffect } from 'react';
import { requestValidator } from 'utils';
import { BIMCreateObj } from 'config';

export const BIMContext = createContext();
export const BatchUploadContext = createContext();

export const BIMContextProvider = props => {
	const [dockerState, setDockerState] = useState('listing');
	const [listingData, setListingData] = useState([]);
	const [selectedMapping, setSelectedMapping] = useState();
	const [activeSection, setActiveSection] = useState('upload_data');
	const [addPopupToggler, setAddPopupToggler] = useState(false);
	const [addValidation, setAddValidation] = useState(false);
	const [fileData, setFileData] = useState();
	const [trailFormulaData, setTrailFormulaData] = useState([]);
	const [alertState, setAlertState] = useState('mailIdsForSucc');
	const [gobackWarning, setGobackWarning] = useState(false);
	const [fileHeaders, setFileHeaders] = useState([]);
	const [sourceData, setSourceData] = useState([]);
	const [batchUploadheaders, setbatchUploadheaders] = useState();
	const [auditData, setauditData] = useState(0);
	const [errorMsgLoadCode, setErrorMsgLoadCode] = useState(null);
	const [formulaIndex, setFormulaIndex] = useState(null);
	const [addNewFactPopup, setAddNewFactPopup] = useState(false);
	const [downloadfile, setdownloadfile] = useState({ type: '', ufl_uploadBatchId: '' });
	const [activeTitle, setActiveTitle] = useState('bfm_linkageCount');
	const [savePopupState, setSavePopupState] = useState(null);
	const [createObj, setCreateObj] = useState(BIMCreateObj);
	const [manualDataUpload, setManualDataUpload] = useState([{ bfm_loadCode: '', version: 3, p_code: '', file: '', mode: '', uploadFrom: false }]);
	const [addNewFact, setAddNewFact] = useState({
		fa_actualDataType: '',
		fa_collection: '',
		fa_description: '',
		fa_eleType: '',
		fgs_code: '',
		fg_position: '',
		fa_example: '',
		fa_formula_type: '',
		fa_isFilterAllowed: '',
		fa_isSortAllowed: '',
		fa_isbimFact: '',
		fa_name: '',
		fa_placeHolder: '',
		fa_type: [],
		fg_isDisabled: ''
	});

	useEffect(() => {
		setAddValidation(requestValidator({ ...createObj, validatorKey: 'bimAdd' }));
	}, [createObj?.bfm_loadCode, createObj?.bfm_description, createObj?.bfm_fileType]);

	const reset = obj => {
		obj?.createObj && setCreateObj(BIMCreateObj);
		setSavePopupState(null);
		setErrorMsgLoadCode(null);
		setDockerState('listing');
		setSelectedMapping(null);
		setActiveSection('upload_data');
		setAddPopupToggler(false);
	};

	const resetAddNewFact = () => {
		setAddNewFact({ fa_actualDataType: '', fa_collection: '', fa_description: '', fa_eleType: '', fgs_code: '', fg_position: '', fa_example: '', fa_formula_type: '', fa_isFilterAllowed: '', fa_isSortAllowed: '', fa_isbimFact: '', fa_name: '', fa_placeHolder: '', fa_type: [], fg_isDisabled: '' })
	}

	return (
		<BIMContext.Provider
			value={{
				dockerState, //store docer state info
				listingData, // BIM Listing Data
				createObj, // BIM CRUD Obj
				selectedMapping, // selected mapping checkbox
				addPopupToggler, // add popup toggler
				activeTitle, // active title tab in listing
				activeSection, // active section in main add
				addValidation, // add validation
				fileData, //store fileData
				fileHeaders, //store fileHeaders info
				sourceData,
				addNewFact, // add a new fact list
				addNewFactPopup, // add a new fact list popup
				trailFormulaData, // store trailFormulaData
				alertState, // alertState info
				auditData, // store auditData info
				manualDataUpload, // store manualDataUpload info
				batchUploadheaders, // store batchUploadheaders info
				errorMsgLoadCode, // store  errorMsg for LoadCode
				formulaIndex, //index for fromula
				downloadfile, //download  errorfile
				gobackWarning, // popup for going back
				savePopupState,
				setManualDataUpload, // store manualDataUpload info
				setErrorMsgLoadCode, // store  errorMsgLoadCode info
				setFormulaIndex, // index for fromula
				setActiveSection, // active section in main add
				setDockerState, // store docer state info
				setActiveTitle, // active title tab in listing
				setListingData, // BIM Listing Data
				setSelectedMapping, // selected mapping checkbox
				setCreateObj, // BIM CRUD Obj
				setAddPopupToggler,
				setAddNewFact,
				setauditData,
				setdownloadfile,
				setbatchUploadheaders,
				setAddNewFactPopup,
				setGobackWarning,
				setAddValidation,
				setFileData,
				setFileHeaders,
				setTrailFormulaData,
				setSourceData,
				setAlertState,
				setSavePopupState,
				reset,
				resetAddNewFact
			}}
		>
			{props.children}
		</BIMContext.Provider>
	);
};

export const BatchUploadContextProvider = props => {
	const [tableHeaders, setTableHeaders] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [createObj, setCreateObj] = useState({});
	const [uploadState, setUploadState] = useState(false);
	const [mappingList, setMappingList] = useState([]);
	const [pageNumber, setPageNumber] = useState(0);

	const mappingData = data => {
		const el = data?.map(elm => ({ key: elm?.bfm_loadCode, value: elm?.bfm_loadCode, bfm_version: elm?.bfm_version }));
		setMappingList(el);
	};

	const reset = () => {
		setCreateObj({});
		setUploadState(false);
	};

	return (
		<BatchUploadContext.Provider value={{ tableHeaders, tableData, createObj, uploadState, mappingList, pageNumber, setPageNumber, mappingData, setUploadState, reset, setCreateObj, setTableData, setTableHeaders }}>
			{props.children}
		</BatchUploadContext.Provider>
	);
};
